import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Tokushoho() {
  usePageMeta({
    title: "特定商取引法に基づく表記 | Biz-AI検定",
    description: "Biz-AI検定の特定商取引法に基づく表記。販売事業者・料金・返金ポリシーをご確認ください。",
  });

  return (
    <div className="min-h-screen bg-[#faf6ee]">
      <header className="border-b border-[#c9bca7]/50 bg-[#f9f4e8]">
        <div className="max-w-3xl mx-auto px-6 py-4">
          <Link href="/" className="inline-flex items-center text-sm text-[#675a49] hover:text-[#2f1d15] transition-colors">
            <ArrowLeft className="w-4 h-4 mr-1" />
            トップに戻る
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-2xl font-bold text-[#4e2b1f] mb-8">特定商取引法に基づく表記</h1>

        <div className="space-y-6 text-[15px] text-[#4e2b1f] leading-relaxed">
          <dl className="space-y-5">
            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">事業者名</dt>
              <dd>合同会社AIM</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">代表者</dt>
              <dd>代表社員 木村 謙介</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">所在地</dt>
              <dd>〒069-0825 北海道江別市野幌東町5-35</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">電話番号</dt>
              <dd>請求があった場合は遅滞なく開示いたします</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">メールアドレス</dt>
              <dd>info@aim-llc.jp</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">販売価格</dt>
              <dd>各試験の申し込みページに表示された金額（税込）</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">販売価格以外の必要料金</dt>
              <dd>なし（インターネット接続にかかる通信料はお客様のご負担となります）</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">支払い方法</dt>
              <dd>クレジットカード（Visa, Mastercard, JCB, American Express）</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">支払い時期</dt>
              <dd>申し込み時に即時決済</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">サービスの提供時期</dt>
              <dd>決済完了後、受験スケジュールに基づきオンラインにて提供</dd>
            </div>

            <div className="border-b border-[#c9bca7]/30 pb-4">
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">返品・キャンセルについて</dt>
              <dd>
                デジタルコンテンツの性質上、決済完了後の返品・返金には原則として応じかねます。
                ただし、サービスの提供に不備があった場合は個別に対応いたします。
              </dd>
            </div>

            <div>
              <dt className="text-xs font-medium text-[#8e7f69] tracking-wider uppercase mb-1">動作環境</dt>
              <dd>
                最新版のGoogle Chrome、Microsoft Edge、Safari、Firefoxを推奨。
                安定したインターネット接続が必要です。
              </dd>
            </div>
          </dl>
        </div>
      </main>

      <footer className="border-t border-[#c9bca7]/50 py-8 px-6 bg-[#f9f4e8]">
        <div className="max-w-3xl mx-auto">
          <p className="text-[12px] text-[#8e7f69]">&copy; 2026 Biz-AI</p>
        </div>
      </footer>
    </div>
  );
}
